/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { Link } from "react-router-dom";
import cn from "clsx";
import { RichTextSimple } from "@simplicitycms/simplicity-richtext";
import { ReactComponent as ChevronLeft } from "cms/assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRight } from "cms/assets/icons/chevron-right.svg";

const BACKGROUND_IMAGE_POSITION = "background";
const RIGHT_IMAGE_POSITION = "right";
const LEFT_IMAGE_POSITION = "left";

const HeroSlide = (props) => {

    const slides = props?.slides;
    const images = props?.images;
    const imagePosition = props?.imagePosition ?? BACKGROUND_IMAGE_POSITION;
    const index = props?.index;
    const total = props?.total;
    const moveIndex = props?.moveIndex;

    const slide = slides[index];
    const image = Array.isArray(images) && images[index];
    const { src, alt } = image || {};

    const { title, subtitle = "", description, link } = slide || {};
    const { text, url: link_url } = link || {};

    const showControls = slides.length > 1;
    const controlsClassName = cn("forward-back", { "hide": !showControls });

    const goToPreviousSlide = () => {
        moveIndex(-1);
    };
    const goToNextSlide = () => {
        moveIndex(1);
    };

    if (imagePosition === BACKGROUND_IMAGE_POSITION) {
        return (
            <div
                className='hero-slide'
                title={alt}
                style={{
                    backgroundImage: `url(${src})`
                }}
            >
                <div className='hero-content-container'>
                    <div className='hero-content'>

                        <h2>
                            {title}
                            {subtitle && <span>{` ${subtitle}`}</span>}
                        </h2>

                        <RichTextSimple
                            richtext={description}
                            className='hero-slide-description'
                        />
                        <Link to={link_url} className='hero-slide-link'>
                            {text}
                        </Link>
                    </div>

                    <div className='hero-controls'>

                        <div className={controlsClassName}>

                            <button aria-label='Previous' onClick={goToPreviousSlide}>
                                <ChevronLeft />
                            </button>

                            <span>{`${index + 1}/${total}`}</span>

                            <button aria-label='Next' onClick={goToNextSlide}>
                                <ChevronRight />
                            </button>

                        </div>
                    </div>
                </div>

            </div>
        );
    }

    const isImageLeft = imagePosition === LEFT_IMAGE_POSITION;
    const isImageRight = imagePosition === RIGHT_IMAGE_POSITION;

    return (
        <div className='hero-slide-left-right' title={alt}>
            <div className='hero-slider-wrapper'>
                {isImageLeft &&
                    <div className='hero-left-container'>
                        <img src={src} alt={alt} />
                    </div>
                }

                <div className='hero-slider-content'>
                    <h1>
                        {title}
                        {subtitle && <span>{" "}{subtitle}</span>}
                    </h1>

                    <RichTextSimple
                        richtext={description}
                        className='hero-slide-description'
                    />
                    {text && link_url &&
                        <Link to={link_url} className='hero-slide-link'>
                            {text}
                        </Link>
                    }
                </div>

                {isImageRight &&
                    <div className='hero-right-container'>
                        <img src={src} alt={alt} />
                    </div>
                }
            </div>

            <div className='hero-left-right-controls'>
                <div className={controlsClassName}>
                    <button aria-label='Previous' onClick={goToPreviousSlide}>
                        <ChevronLeft />
                    </button>
                    <div>{`${index + 1}/${total}`}</div>

                    <button aria-label='Next' onClick={goToNextSlide}>
                        <ChevronRight />
                    </button>
                </div>
            </div>
        </div>
    );

};
export { HeroSlide };
